<lyceo-content [background]="true">
  <lyceo-single-card-layout *transloco="let t">
    <homi-logo class="mb-5" header />
    <h3 class="mb-3">{{ t('pages.no_access.title') }}</h3>
    <p class="mb-3">{{ t('pages.no_access.description') }}</p>
    <p class="mb-3">
      {{ t('pages.no_access.contact_before') }}
      <a href="mailto:support@homi.nu">support@homi.nu</a
      >{{ t('pages.no_access.contact_after') }}
    </p>
    <button
      lyceoButton
      (click)="logout()"
      [block]="true"
      data-testid="logout-button"
    >
      <fa-icon [icon]="faRightFromBracket" />
      {{ t('pages.no_access.logout') }}
    </button>
  </lyceo-single-card-layout>
</lyceo-content>
